<template>
  <div>
    <sideBarOrderModal
      v-if="orderModalData.open"
      :modalData="orderModalData"
      :onModalClose="closeModal"
      :fetchOrders="fetchOrders"
    />

    <PhoneBlackListEditModal
      v-if="blackListPhoneNum"
      :blackListPhoneNum="blackListPhoneNum"
      :onCancel="closeBlackList"
    />

    <SendLetterModal
      v-if="sendLetterModalData"
      :modalData="sendLetterModalData"
      :onModalClose="closeModal"
    />

    <table class="table table-bordered1 table-hover orders_table">
      <thead>
      <tr>
        <th v-if="selectAll">
          <input type="checkbox" @change="updateSelected($event)"/>
        </th>
        <th v-if="oldOrders"></th>
        <th class="w-90p">
          ID
          <i
            v-if="sorting"
            class="icon-fa"
            @click="updateSorting('id')"
            v-bind:class="{
                'icon-fa-long-arrow-up': !sorting.id.sort,
                'icon-fa-long-arrow-down': sorting.id.sort,
                active: sorting.id.active
              }"
          ></i>
          <hr/>
          Создание
        </th>
        <th class="w-90p">
          Доставка
          <i
            v-if="sorting"
            class="icon-fa"
            @click="updateSorting('delivery_date')"
            v-bind:class="{
                'icon-fa-long-arrow-up': !sorting.delivery_date.sort,
                'icon-fa-long-arrow-down': sorting.delivery_date.sort,
                active: sorting.delivery_date.active
              }"
          ></i>
          <hr/>
          Проект
        </th>
        <th class="w-12P">Клиент</th>
        <th class="w-20P">Адрес</th>
        <th class="hidden" width="130px">Телефон</th>
        <th>
          Препараты
          <i
            v-if="sorting"
            class="icon-fa"
            @click="updateSorting('drug')"
            v-bind:class="{
                'icon-fa-long-arrow-up': !sorting.drug.sort,
                'icon-fa-long-arrow-down': sorting.drug.sort,
                active: sorting.drug.active
              }"
          ></i>
        </th>
        <th class="w-12p"></th>
        <th class="w-70p">
          Сумма
          <i
            v-if="sorting"
            class="icon-fa"
            @click="updateSorting('price')"
            v-bind:class="{
                'icon-fa-long-arrow-up': !sorting.price.sort,
                'icon-fa-long-arrow-down': sorting.price.sort,
                active: sorting.price.active
              }"
          ></i>
        </th>
        <th v-if="!disableEdit"></th>
      </tr>
      </thead>
      <tbody>
      <tr
        v-for="(order, index) in orders"
        v-if="order && !(order.visible === false)"
        :class="getClassByOrderStatus(order.status)"
        :key="order.id"
      >
        <td v-if="selectAll">
          <input
            type="checkbox"
            :disabled="selected[order.id].disabled"
            v-model="selected[order.id].value"
          />
        </td>
        <td v-if="oldOrders">
          <input type="checkbox" v-model="selected[order.id]"/>
        </td>
        <td>
          <p>{{ order.id }}</p>
          <hr/>
          <p class="text_date">
            {{ moment(order.created_at, 'DD.MM.YYYY') }}
          </p>
          <p class="text_date">
            {{ printDate(order.created_at, 'HH:mm') }}

            <template v-if="editComment">
              <i
                @click="openCommentModal(order)"
                class="comment_icon icon-fa icon-fa-commenting"
              ></i>
            </template>

            <template
              v-if="(order.comment && order.comment.length && !editComment) || order.reject_comment || (order.extra_options?.comments_for_runner ?? []).length"
            >
              <i
                v-tooltip="{
                    content: getComments(order),
                    placement: 'bottom-center',
                    classes: ['info custom-tooltip'],
                    targetClasses: ['it-has-a-tooltip custom-tooltip'],
                    offset: 10,
                    delay: {
                      show: 200,
                      hide: 700
                    }
                  }"
                class="icon-fa icon-fa-info-circle comment_tooltip_fa"
              ></i>
            </template>
          </p>
          <p v-if="order.is_reserved"><span class="badge badge-info">В резерве</span></p>
        </td>
        <td>
          <p class="text_date">{{ printOrderDate(order) }}</p>
          <hr/>
          <p>
            <!--            <strong v-if="projects">{{ projects[order.site_id] }}</strong>-->
            <strong>{{
                $AllProjects[order.site_id] && $AllProjects[order.site_id].title || order.project_label
              }}</strong> <span class="badge badge-danger" v-if="order.site_mirror_id">{{
              getMirrorName(order)
            }}</span>
            <span v-if="order.dialog_chat_bot_id" class="badge badge-info">ЧатБот</span>
            <span v-if="order.site_source" class="badge badge-info">{{ order.site_source }}</span>
            <span v-if="order.type_id == 2" class="order_type refund">Возврат ({{ order.related_order_id }})</span>
            <span
              v-if="order.extra_options && order.extra_options.byAgentReSeller"
              class="badge badge-info"
            >Агент по продажам</span
            >
          </p>
          <p v-if="order.type_id === 4"><span class="badge badge-success">Запрос на звонок</span></p>
          <OrderStatus v-if="showStatus" :status="order.status"/>
          <span v-if="order.delivery_date" class="badge badge-default">Доставка: {{
              moment(order.delivery_date, 'DD.MM')
            }}</span>

          <div v-if="order.track_number || order.extra_options.post_track">
            <span>
              {{ order.track_number || order.extra_options.post_track }}
            <a
              target="_blank"
              :href="`https://www.pochta.ru/tracking#${order.track_number || order.extra_options.post_track}`"
            >
              <i class="icon-fa icon-fa-info-circle"></i>
            </a>
            </span>
          </div>
          <template v-if="mixinIsAllowToEditOrder(order)">
            <div class="flex">
              <button
                @click="openOrderInModal(order.id)"
                class="btn btn-xs btn-info newWindowBtn mr-1"
              >
                <template v-if="order.status === 0 && !isOrderUnderManagerProgress(order.id)">
                  взять в работу
                </template>
                <template v-else-if="order.status === 0 && isOrderUnderManagerProgress(order.id, true)">
                  <div class="time_ago_block">
                    <OrderInProgressByManager :orderId="order.id"/>
                  </div>
                </template>
                <template v-else>
                  <i class="icon-fa icon-fa-eye"></i>
                </template>
              </button>
            </div>
          </template>
        </td>
        <td>
          <div class="flex justify-content-between">
            <p>
              <i
                v-if="order.client && order.client.comment"
                v-tooltip="{
                    content: order.client.comment,
                    placement: 'bottom-center',
                    classes: ['info custom-tooltip'],
                    targetClasses: ['it-has-a-tooltip custom-tooltip'],
                    offset: 10,
                    delay: {
                      show: 200,
                      hide: 700
                    }
                  }"
                class="icon-fa icon-fa-info-circle comment_tooltip_fa"
              ></i>
              {{ getClientName(order) }}
            </p>
          </div>
          <p v-if="order.is_customer_trusted"><span
            class="badge badge-success">постоянный ({{ order.is_customer_trusted }})</span></p>
          <div
            v-if="oldOrders && oldOrders[order.id]"
            v-html="printOldData('client', oldOrders[order.id])"
          />
          <div class="flex" v-for="phone in (order.order_phones || [])" :key="phone.id">
            <div>
              <i
                v-if="phone.comment"
                v-tooltip="{
                    content: phone.comment,
                    placement: 'bottom-center',
                    classes: ['info custom-tooltip'],
                    targetClasses: ['it-has-a-tooltip custom-tooltip'],
                    offset: 10,
                    delay: {
                      show: 200,
                      hide: 700
                    }
                  }"
                class="icon-fa icon-fa-info-circle comment_tooltip_fa"
              ></i>
              <strong>{{
                  mixinPrintPhone(phone?.phone?.phone ?? '')
                }}</strong>
              <template v-if="phone && phone.black_list && phone.black_list.id">
                <p class="badge bg-dark pointer" @click="openBlackListData(phone.phone.full_phone)">черный список</p>
              </template>
            </div>
          </div>
          <template v-if="!order.order_phones || !order.order_phones.length">
            <div class="flex">
              <strong>{{ order.phone }}</strong>
              <template v-if="editAvailable || allowToEditByUser(order)">
              </template>
            </div>
          </template>
          <template v-if="order.extra_options?.noAnswerCallOrder">
            <span class="badge badge-warning">недозвонов: <strong>{{
                order.extra_options.noAnswerCallOrder
              }}</strong></span>
          </template>
          <p v-if="((order.extra_options && order.extra_options.email) || (order.client && order.client.email))">
            {{ order.extra_options.email || (order.client && order.client.email) }}
          </p>
          <div v-if="false && !order.city_id" class="flex">
            <template v-if="order.letters && order.letters.length">
              <Letters :letters="order.letters"/>
            </template>
            <div class="send_letter">
              <i
                @click="onLetterModal(order)"
                class="icon-fa icon-fa-share-square-o"
              ></i>
            </div>
          </div>

          <div v-if="allowToHotCall" class="flex">
            <template
              v-if="order.is_agreed"
            >
              <span class="badge badge-success">Согласовано</span>
            </template>
            <template v-else>
              <button
                @click="modalHotCall(order)"
                class="btn btn-xs btn-primary modal_call_btn"
              >
                Прозвон
              </button>
              <button
                @click="modalReject(order)"
                class="btn btn-xs btn-warning modal_call_btn"
              >
                Отмена
              </button>
            </template>
          </div>
          <div
            v-if="
                allowToHotCall &&
                  order.extra_options &&
                  order.extra_options.callDeal
              "
          >
            <button
              @click="modalReject(order, 'agreement')"
              class="btn btn-xs btn-warning modal_call_btn"
            >
              Отменить согласование
            </button>
          </div>
        </td>
        <td class="w-20P relative">
          <div class="chat_btn flex">
            <button v-if="order.dialogs && order.dialogs.length" class="btn btn-default btn-sm" type="button"
                    @click="getActiveDialogs(order.id)">
              <i class="icon-fa icon-fa-weixin chat_icon"/>
            </button>
            <AttachedFiles v-if="(order.files ?? []).length" :files="order.files" :hideText="true"/>
            <div class="" v-if="sendMessageModal[order.id].runner">
              <button class="btn btn-default btn-sm" type="button"
                      @click="sendTelegramMessage(order.id, 'runnerModal')">
                <i class="icon-fa icon-fa-motorcycle chat_icon"/>
              </button>
              <SendRunnerMessage
                v-if="sendMessageModal[order.id].runnerModal"
                :data="order"
                type="runner"
                :onModalClose="() => sendMessageModal[order.id].runnerModal = false"
              />
            </div>
          </div>
          <p>
            <strong>{{ printCity(order.city_id, order.type_id) }}</strong>
            <span v-if="order.city_name">({{ order.city_name }})</span>
            <strong v-if="order.division_id" class="division_label">{{
                $AllDivisions[order.division_id]?.title
              }}</strong>
          </p>
          <div class="flex">
            <v-popover v-if="order.city_id && order.address && order.address.length > 30"
                       :auto-hide="true"
                       placement="right"
                       popoverClass="order_address_map_popover"
                       popoverInnerClass="order_address_map_popover_inner"
                       :delay='{ show: 500, hide: 500 }'
            >
              <button class="btn btn-xs btn-outline-info mr-1"><i
                class="icon-fa icon-fa-map-marker"/>
              </button>
              <template slot="popover">
                <AddressMap :orderId="order.id" :cityId="order.city_id"/>
              </template>
            </v-popover>
            <span>{{ order.address }}</span>
          </div>
          <i v-if="order.extra_options?.address_details">{{ order.extra_options.address_details }}</i>
          <div
            v-if="oldOrders && oldOrders[order.id]"
            v-html="printOldData('address', oldOrders[order.id])"
          />
          <p v-if="order.extra_options && order.extra_options.post_index">
            индекс: {{ order.extra_options.post_index }}
          </p>
          <hr v-if="order.discount || order.delivery_price"/>
          <p v-if="order.discount">
            Скидка: <strong>{{ order.discount }}</strong>
            {{ order.discount_type == 1 ? '%' : 'руб' }}
            <span v-if="order.currency_id && +order.discount_type === 0"> (<strong>{{
                order.currency_discount
              }}</strong> {{ $AllCurrencies[order.currency_id]?.currency }})</span>
          </p>
          <p>
            <span v-if="order.delivery_price">Доставка: <strong>{{ order.delivery_price }}</strong> руб</span>
            <span v-if="order.currency_id && order.currency_delivery"> (<strong>{{
                order.currency_delivery
              }}</strong> {{ $AllCurrencies[order.currency_id]?.currency }})</span>
          </p>
          <RunnerSalaryRate :rate="order?.extra_options?.salary_rate ?? 0"/>
          <template v-if="order.courier && allowToShowRunner(order)">
            <hr/>
            <p>
              курьер: <strong>{{ order.courier.name }}</strong>
            </p>
            <!--            <p v-if="order.courier.phone">{{ order.courier.phone }}</p>-->
          </template>
        </td>
        <td class="hidden">
          <div v-html="printPhones(order)"></div>
          <p v-if="order.extra_options && order.extra_options.email">
            {{ order.extra_options.email }}
          </p>
          <!--          <div-->
          <!--            v-if="oldOrders && oldOrders[order.id]"-->
          <!--            v-html="printOldData('phones', oldOrders[order.id])"-->
          <!--          />-->

          <div v-if="allowToHotCall" class="flex">
            <template
              v-if="order.is_agreed"
            >
              <span class="badge badge-success">Согласовано</span>
            </template>
            <template v-else>
              <button
                @click="modalHotCall(order)"
                class="btn btn-xs btn-primary modal_call_btn"
              >
                Прозвон
              </button>
              <button
                @click="modalReject(order)"
                class="btn btn-xs btn-warning modal_call_btn"
              >
                Отмена
              </button>
            </template>
          </div>
          <div
            v-if="
                allowToHotCall &&
                  order.extra_options &&
                  order.extra_options.callDeal
              "
          >
            <button
              @click="modalReject(order, 'agreement')"
              class="btn btn-xs btn-warning modal_call_btn"
            >
              Отменить согласование
            </button>
          </div>
        </td>
        <td>
          <template v-for="(d, i) in (order.details ?? [])" v-if="d.type_id !== 1"> <!-- drugs for sale only -->
            <DrugRecord :orderDetail="d" :order="order"/>
            <hr v-if="i < (order.details.length - 1)" class="mb-1 mt-1">
          </template>
          <div
            v-if="oldOrders && oldOrders[order.id]"
            v-html="printOldData('drugs', oldOrders[order.id])"
          />
          <div class="delivery_pass_details alert alert-info mb-0"
               v-if="order.extra_options && order.extra_options.pass_to_delivery_system">
            <p>
              <i v-bind:class="{'icon-fa': true,
              'icon-fa-phone': +order.extra_options.pass_to_delivery_system.status === 9999,
              'icon-fa-internet-explorer': +order.extra_options.pass_to_delivery_system.status !== 9999
              }"/>&nbsp;
              согласование
              <strong>{{
                  $AllProjects[order.extra_options.pass_to_delivery_system.site_id] && $AllProjects[order.extra_options.pass_to_delivery_system.site_id].title
                }}</strong>
              выполнено {{ printDate(order.extra_options.pass_to_delivery_system.date, 'DD.MM.YYYY HH:mm', false, 0) }}
              {{ order.extra_options.pass_to_delivery_system.user_name }}
            </p>
          </div>
        </td>
        <td>
          <div v-if="editAvailable && changeSubStatus">
            <select
              @change="updateSubStatus(order)"
              class="form-control"
              v-model="order.sub_status"
            >
              <option value="0">Не обрабатывалась</option>
              <option v-for="(status, index) in subStatuses" :value="index">{{
                  status
                }}
              </option>
            </select>
            <div>
              <button
                @click="modalReject(order, 'order', true)"
                class="btn btn-xs btn-warning modal_call_btn"
              >
                отменить заявку
              </button>
            </div>
          </div>
          <div v-if="createRefundAllow && order.type_id !== 2">
            <button @click="openModal(order)" class="btn btn-warning btn-xs">
              Возврат
            </button>
          </div>
        </td>
        <td>
          <p v-if="order.pay_method === 3">
            <span
              v-bind:class="{
              'badge pointer': true,
              'badge-warning': +order.price > +order.no_cash_price,
              'badge-success': !(+order.price > +order.no_cash_price)
            }"
              v-tooltip="{
                  content: getPrePaidData(order),
                  placement: 'bottom-center',
                  classes: ['info custom-tooltip'],
                  targetClasses: ['it-has-a-tooltip custom-tooltip'],
                  offset: 10,
                  delay: {
                    show: 200,
                    hide: 700
                  }
                }"
            >
              <i v-bind:class="{'icon-fa icon-fa-credit-card': true}"/> {{ order.no_cash_price }}
            </span>
          </p>
          <p><strong class="price_strong">{{ order.price }}</strong>
            <span v-if="order.currency_id && order.currency_id !== $platformConstants.operationCurrency.id"> (<strong>{{
                order.currency_id_price
              }}</strong> {{ $AllCurrencies[order.currency_id]?.currency }})</span>
          </p>
          <div v-if="$currentRole == 'admin' && newStoreData">
            <template
              v-for="detail in order.details"
              v-if="debugDrug == detail.drug_id"
            >
              <div
                v-html="
                    printStoreData(
                      detail.drug_id,
                      newStoreData.inStores[detail.drug_id],
                      newStoreData.reservation[detail.drug_id]
                    )
                  "
              ></div>
            </template>
          </div>
          <span
            v-if="oldOrders"
            v-html="printOldData('new_price_syncro', order)"
          />

          <span v-if="order.no_cash_price && order.pay_method !== 3" class="badge badge-info">ожидается перевод</span>

          <template v-if="order.payment || order.pay_method === 3">
            <i
              v-tooltip="{
                  content: getPrePaidData(order),
                  placement: 'bottom-center',
                  classes: ['info custom-tooltip'],
                  targetClasses: ['it-has-a-tooltip custom-tooltip'],
                  offset: 10,
                  delay: {
                    show: 200,
                    hide: 700
                  }
                }"
              class="icon-fa icon-fa-money payment_icon"
            >
            </i>
          </template>
          <div class="flex">
            <div
              v-if="oldOrders && oldOrders[order.id]"
              v-html="printOldData('price', oldOrders[order.id])"
            />
            <div class="mr-1" v-if="sendMessageModal[order.id].supervisor">
              <button @click="sendTelegramMessage(order.id, 'supervisorModal')" type="button"
                      class="btn btn-default btn-sm">
                <i class="icon-fa icon-fa-user-secret chat_icon"/>
              </button>
              <SendRunnerMessage
                v-if="sendMessageModal[order.id].supervisorModal"
                :data="order"
                type="supervisor"
                :onModalClose="() => sendMessageModal[order.id].supervisorModal = false"
              />
            </div>

            <div v-if="allowPrePaid(order)">
              <PrePaidButton :order="order"/>
            </div>
          </div>
        </td>
        <td v-if="!disableEdit">
          <template v-if="ableToEdit && !editAvailable">
            <div class="flex">
              <button
                @click="openOrderInModal(order.id)"
                class="btn btn-xs btn-info newWindowBtn mr-1"
              >
                <i class="icon-fa icon-fa-eye"></i>
              </button>
              <button
                @click="openEditOrderPage(order.id)"
                class="btn btn-info btn-xs"
              >
                <i class="icon-fa icon-fa-edit"></i>
              </button>
            </div>
          </template>
        </td>
      </tr>
      </tbody>
    </table>

    <customModal
      v-if="modalData"
      v-show="modalData"
      :onModalClose="onModalClose"
      :onModalAccept="updateSubStatusByModal"
      :modalData="modalData"
    ></customModal>
    <customModal
      v-if="modalDataReject"
      v-show="modalDataReject"
      :onModalClose="onModalClose"
      :onModalAccept="rejectOrder"
      :modalData="modalDataReject"
    ></customModal>

    <editCommentModal
      v-if="editComment && modalCommentData"
      v-show="modalCommentData"
      :onModalClose="onModalClose"
      :modalData="modalCommentData"
      :updateOrder="updateOrderData"
    />
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import VueLadda from 'vue-ladda/src/vue-ladda.vue'
import customModal from '@/components/modals/customModal'
import editCommentModal from '@/components/modals/orders/editComment'
import sideBarOrderModal from '../modals/orders/sideBarOrderModal'
import Letters from './ordersData/Letters'
import SendLetterModal from './ordersData/SendLetterModal'
import MakeCall from './telephony/MakeCall'
import PhoneBlackListEditModal from '../../components/clients/PhoneBlackListEditModal'
import SendRunnerMessage from '@/components/telegram/SendRunnerMessage'
import PrePaidButton from "@/components/orders/prePaid/PrePaidButton";
import DrugRecord from "@/components/orders/components/DrugRecord.vue";
import AddressMap from "@/components/map/AddressMap.vue";
import RunnerSalaryRate from "@/views/orders/RunnerSalaryRate.vue";
import UserName from "@/components/users/UserName.vue";
import TimeAgo from "vue2-timeago";
import OrderInProgressByManager from "@/views/orders/components/OrderInProgressByManager.vue";
import OrderStatus from "@/components/orders/ordersData/OrderStatus.vue";
import AttachedFiles from "@/components/orders/files/AttachedFiles.vue";

export default {
  components: {
    AttachedFiles,
    OrderStatus,
    OrderInProgressByManager,
    UserName,
    RunnerSalaryRate,
    AddressMap,
    PhoneBlackListEditModal,
    SendLetterModal,
    Letters,
    VueLadda,
    customModal,
    editCommentModal,
    sideBarOrderModal,
    SendRunnerMessage,
    MakeCall,
    PrePaidButton,
    DrugRecord,
    TimeAgo,
  },
  props: [
    'disableEdit',
    'sitesToEdit',
    'projects',
    'cities',
    'orders',
    'oldOrders',
    'subStatuses',
    'displayType',
    'openModal',
    'orderType',
    'updateOrders',
    'allowToHotCall',
    'externalUpdateOrder',
    'resetSubStatus',
    'inStore',
    'availableToSend',
    'confirmedDrugs',
    'drugsTransits',
    'inSendStore',
    'updateConfirmedDrug',
    'editInNewPage',
    'editComment',
    'disableSupplyDrugs',
    'newStoreData',
    'debugDrug',
    'drugDynamicStoreData',
    'updateDynamicStoreDataByOrder',
    'type',
    'searchOrders',
    'sorting',
    'allowSupplyDrugs',
    'profileEditLink',
    'fetchOrders',
    'allowToCall'
  ],
  computed: {
    $AllCurrencies() {
      return this.$store.getters['platform/currencies']
    },
    $LetterTypes() {
      return this.$store.getters['orders/letterTypes']
    },
    $AllCities() {
      return this.$store.getters['platform/cities']
      let cities = this.$store.getters['platform/cities']
      cities[0] = {id: 0, name: 'Почта', short_name: 'Почта'}
      return cities
    },
    $AllProjects() {
      const sites = this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        },
        {}
      );
      return sites;
    },
    $StoresNotificationSettings() {
      return this.$store.getters['platform/storeNotificationSettings']
    },
    $AllDivisions() {
      return this.$store.getters['platform/divisions']
    },
  },
  data() {
    return {
      citiesWithGeo: [1, 13],
      copyOrderBtnLoading: {},
      blackListPhoneNum: null,
      sendLetterModalData: null,
      modalCommentData: null,
      ableToEdit: false,
      showStatus: true,
      changeSubStatus: true,
      sendOrderBtnLoading: false,
      selectAll: false,
      editAvailable: false,
      createRefundAllow: false,
      selected: {},
      modalData: null,
      modalDataReject: null,
      dynamicStore: {},
      orderModalData: {},
      sendMessageModal: {},
    }
  },
  async mounted() {
    if (!this.$LetterTypes) {
      const {data} = await api.index('store/orders/lettertypes')
      if (data.success) {
        this.$store.dispatch('orders/setLetterTypes', data.records)
      }
    }
  },
  created() {
    if (this.$can('orders/viewClosed') || this.$can('orders/editClosed') || this.$currentRole == 'admin') {
      this.ableToEdit = true
    }

    if (this.orderType && this.orderType == 'manual') {
      this.showStatus = false
      this.changeSubStatus = false
      this.orders.forEach(o => {
        let disabled = false
        if (o.city_id === 0 && !o.payment) disabled = true
        if (!o.order_phones || o.order_phones.length == 0) disabled = true
        this.$set(this.selected, o.id, {value: false, disabled: disabled})
      })
      this.selectAll = true
    }

    const sendMessageModal = {}
    // const citiesToStores = Object.values(this.$AllDivisions).reduce((acc, d) => {
    //   d.cities.forEach((c) => {
    //     acc[c.object_id] = d.stores[0].object_id
    //   })
    //   return acc
    // }, {})
    this.orders.forEach(o => {
      sendMessageModal[o.id] = {
        runner: this.$StoresNotificationSettings[o.store_id]?.runner?.[o.status] > 0,
        supervisor: this.$StoresNotificationSettings[o.store_id]?.supervisor?.[o.status] > 0,
        runnerModal: false,
        supervisorModal: false,
      }
    })
    this.sendMessageModal = {...sendMessageModal}

    if (this.displayType && this.displayType == 'manager')
      this.editAvailable = true
    if (this.displayType && this.displayType == 'natural')
      this.editAvailable = false
    if (this.displayType && this.displayType == 'refund')
      this.createRefundAllow = true
    if (this.inStore) this.dynamicStore = {...this.inStore}

    if (this.confirmedDrugs) {
      Object.keys(this.confirmedDrugs).forEach(drugId => {
        this.dynamicStore[drugId] -= this.confirmedDrugs[drugId]
      })
    }
  },
  methods: {
    allowPrePaid(order) {
      const compareDate = moment().subtract(2, 'days').format('dd-mm-yyyy');
      const allowByDate = moment(order.report_date).format('dd-mm-yyyy') > compareDate;
      return this.$currentRole == 'admin' || ([9999, 0, 1, 2].includes(order.status) && order.type_id !== 2) || allowByDate;
      // return [0, 1].includes(order.city_id) && [9999, 0, 1, 2, 3].includes(order.status) && order.type_id !== 2
    },
    getActiveDialogs(orderId) {
      this.$store.dispatch('platform/setGlobalDrawerData', {
        data: {orderId: orderId, type: 'dialogs'},
        callBackAction: 'refreshList'
      })
    },
    getMirrorName(order) {
      const mirror = this.$AllProjects[order.site_id].mirrors.find(m => m.id === order.site_mirror_id);
      return mirror && mirror.title || null
    },
    sendTelegramMessage(orderId, type) {
      this.sendMessageModal[orderId][type] = true
    },
    async copyOrder(id) {
      if (!this.copyOrderBtnLoading[id]) {
        this.copyOrderBtnLoading[id] = true
        this.copyOrderBtnLoading = {...this.copyOrderBtnLoading}
      } else {
        this.copyOrderBtnLoading[id] = true
      }
      let {data} = await api.index('/orders/copyOrder/' + id)
      if (data.success) {
        toastr['success'](data.message || 'сохранено')
        this.mixinGoToRouter('editOrder', {id: data.orderId})
      } else {
        toastr['warning'](data.message || 'ошибка сервера')
      }
      this.copyOrderBtnLoading[id] = false
    },
    openBlackListData(phoneNum) {
      this.blackListPhoneNum = phoneNum
    },
    closeBlackList() {
      this.blackListPhoneNum = null
    },
    onLetterModal(order) {
      this.sendLetterModalData = {
        order: order
      }
    },
    closeModal() {
      this.orderModalData = {open: false}
      this.sendLetterModalData = null
    },
    async openOrderInModal(orderId) {
      if (!this.isOrderUnderManagerProgress(orderId)) {
        const result = await this.updateOrderUnderManagerProgress(orderId);
        if (!result.success) {
          toastr['warning'](result.message ?? 'не обновились динамические данные', 'Ошибка!');
          return;
        }
      }
      this.$store.dispatch('orders/setOrderToEdit', {orderId: orderId, callBackAction: 'refreshList'})
    },
    updateSorting(field) {
      Object.keys(this.sorting).forEach(k => {
        this.sorting[k].active = false
      })
      this.sorting[field].active = true
      this.sorting[field].sort = !this.sorting[field].sort
      this.searchOrders()
    },
    printStoreData(drugId, store, reservation) {
      let text = ''
      let sum1 = 0
      let sum2 = 0
      let confirmedReservationMS =
        reservation[this.newStoreData.motherStoreId] &&
        reservation[this.newStoreData.motherStoreId].confirmed
          ? reservation[this.newStoreData.motherStoreId].confirmed
          : 0

      let sum3 =
        (store[this.newStoreData.motherStoreId]
          ? store[this.newStoreData.motherStoreId]
          : 0) -
        (this.newStoreData.transitDetails[drugId] &&
        this.newStoreData.transitDetails[drugId][
          this.newStoreData.motherStoreId
          ]
          ? this.newStoreData.transitDetails[drugId][
          this.newStoreData.motherStoreId
          ].in || 0
          : 0) -
        confirmedReservationMS

      let sum4 = sum3

      let confirmedDrugs = {
        current: 0,
        daughter: 0,
        mother: 0,
        motherOnly: 0
      }
      let transitInToMother =
        this.newStoreData.transitDetails[drugId] &&
        this.newStoreData.transitDetails[drugId][
          this.newStoreData.motherStoreId
          ]
          ? this.newStoreData.transitDetails[drugId][
          this.newStoreData.motherStoreId
          ].in || 0
          : 0

      Object.keys(store).forEach(storeId => {
        let confirmedReservation =
          reservation[storeId] && reservation[storeId].confirmed
            ? reservation[storeId].confirmed
            : 0
        let nonConfirmedReservation =
          reservation[storeId] && reservation[storeId].nonConfirmed
            ? reservation[storeId].nonConfirmed
            : 0
        let transitIn =
          this.newStoreData.transitDetails[drugId] &&
          this.newStoreData.transitDetails[drugId][storeId]
            ? this.newStoreData.transitDetails[drugId][storeId].in || 0
            : 0
        let transitOut =
          this.newStoreData.transitDetails[drugId] &&
          this.newStoreData.transitDetails[drugId][storeId]
            ? this.newStoreData.transitDetails[drugId][storeId].out || 0
            : 0

        text +=
          '<p><strong class="title_span" title="' +
          transitIn +
          '/' +
          transitOut +
          '">S:' +
          storeId +
          '</strong> => ' +
          store[storeId] +
          '/' +
          confirmedReservation +
          '/' +
          +nonConfirmedReservation +
          '/' +
          (store[storeId] - confirmedReservation) +
          '/' +
          (store[storeId] - confirmedReservation > 0
            ? 0
            : store[storeId] - confirmedReservation) +
          '/' +
          (store[storeId] - confirmedReservation - nonConfirmedReservation) +
          '/' +
          (store[storeId] - confirmedReservation - nonConfirmedReservation < 0
            ? store[storeId] - confirmedReservation - nonConfirmedReservation
            : 0) +
          '</p>'

        if (this.newStoreData.selectedStore == storeId) {
          sum1 += 0 - (store[storeId] - confirmedReservation)
          sum2 +=
            0 -
            (store[storeId] - confirmedReservation - nonConfirmedReservation)
          confirmedDrugs.current = confirmedReservation
        }

        if (
          this.newStoreData.selectedStore != storeId &&
          !this.newStoreData.daughterStores[storeId] &&
          this.newStoreData.daughterSendStores[storeId]
        ) {
          sum3 +=
            store[storeId] - confirmedReservation > 0
              ? 0
              : store[storeId] - confirmedReservation
          confirmedDrugs.mother += confirmedReservation
        }

        if (this.newStoreData.motherStoreId == storeId) {
          confirmedDrugs.motherOnly = confirmedReservation
        }

        if (this.newStoreData.daughterStores[storeId]) {
          sum1 -=
            store[storeId] - confirmedReservation > 0
              ? 0
              : store[storeId] - confirmedReservation
          sum2 -=
            store[storeId] - confirmedReservation - nonConfirmedReservation < 0
              ? store[storeId] - confirmedReservation - nonConfirmedReservation
              : 0
          confirmedDrugs.daughter += confirmedReservation
        }
      })

      let calculation = ''
      let calculationNum = 0

      if (sum3 <= 0) {
        calculation +=
          '<p>V1: ' +
          (sum1 < sum4 ? (sum1 < 0 ? 0 : sum1) : sum4 < 0 ? 0 : sum4) +
          '</p>'
        calculationNum =
          sum1 < sum4 ? (sum1 < 0 ? 0 : sum1) : sum4 < 0 ? 0 : sum4
      } else {
        calculation +=
          '<p>V2: ' +
          (sum2 < sum3 ? (sum2 < 0 ? 0 : sum2) : sum3 < 0 ? 0 : sum3) +
          '</p>'
        calculationNum =
          sum2 < sum3 ? (sum2 < 0 ? 0 : sum2) : sum3 < 0 ? 0 : sum3
      }

      let transitIn =
        this.newStoreData.transitDetails[drugId] &&
        this.newStoreData.transitDetails[drugId][
          this.newStoreData.selectedStore
          ] &&
        this.newStoreData.transitDetails[drugId][
          this.newStoreData.selectedStore
          ].in
          ? this.newStoreData.transitDetails[drugId][
            this.newStoreData.selectedStore
            ].in
          : 0
      let allowToUse = calculationNum + store[this.newStoreData.selectedStore]
      let totalConfirmed = confirmedDrugs.current + confirmedDrugs.daughter

      let clearedText =
        '<p>Всего в распоряжении: <strong>' +
        allowToUse +
        '</strong></p>' +
        '<p>На складе: ' +
        (store[this.newStoreData.selectedStore] - transitIn) +
        '</p>'
      if (transitIn) {
        clearedText += '<p>в дороге: ' + transitIn + '</p>'
      }
      if (calculationNum) {
        clearedText += '<p>возможно отправить: ' + calculationNum + '</p>'
      }

      let confirmedText =
        '<p>Согласовано..: <strong>' + totalConfirmed + '</strong>'
      if (confirmedDrugs.daughter) {
        confirmedText += ' ('
        if (confirmedDrugs.current)
          confirmedText +=
            'из них ' + confirmedDrugs.current + ' текущий склад, '
        confirmedText += 'из них ' + confirmedDrugs.daughter + ' дочерние)'
      }
      confirmedText += '</p>'

      let readyToSend =
        totalConfirmed - store[this.newStoreData.selectedStore] >
        store[this.newStoreData.motherStoreId] -
        transitInToMother -
        confirmedDrugs.motherOnly
          ? store[this.newStoreData.motherStoreId] -
          transitInToMother -
          confirmedDrugs.motherOnly
          : totalConfirmed - store[this.newStoreData.selectedStore]
      if (readyToSend < 0) readyToSend = 0

      text +=
        '<div>' +
        '<p>Первый просчет: ' +
        sum1 +
        '</p>' +
        '<p>Второй просчет: ' +
        sum2 +
        '</p>' +
        '<p>Третий просчет: ' +
        sum3 +
        '</p>' +
        '<p>Четвертый просчет: ' +
        sum4 +
        '</p>' +
        calculation +
        '<p>Динамический остаток: <strong>' +
        (allowToUse - totalConfirmed) +
        '</strong></p>' +
        clearedText +
        confirmedText +
        '<p>Готовим к отправке: <strong>' +
        readyToSend +
        '</strong></p>' +
        '</div>'

      return text
    },
    allowToShowRunner(order) {
      if (
        order.status == 2 ||
        order.status == 3 ||
        order.status == 11 ||
        order.status == -3
      )
        return true
      return false
    },
    allowToEditByUser(order) {
      if ([2, 3, 11].includes(order.status)) return false
      if (this.$orderAccess && Object.keys(this.$orderAccess).length) {
        if ((this.$orderAccess.all && (this.$orderAccess.all.all || this.$orderAccess.all[order.city_id]))
          || (this.$orderAccess[order.site_id] &&
            (this.$orderAccess[order.site_id].all || this.$orderAccess[order.site_id][order.city_id]))
        ) {
          return true
        }
        return false
      }

      if (this.sitesToEdit && !(this.ableToEdit && !this.editAvailable)) {
        if (
          (order.status == 0 || order.status == 9999 || order.status === 8 || order.status == -3 || order.status == -2) &&
          this.sitesToEdit[order.site_id]
        )
          return true
      }
      return false
    },
    updateOrderData(order) {
      if (!order) return
      this.orders[order.id] = order
    },
    openCommentModal(order) {
      this.modalCommentData = order
      // console.log(this.modalCommentData)
    },
    printOldData(type, order) {
      let text = '<p class="old_order_data">'
      let new_text = false
      let sum = 0
      let result
      let syncroMessage = ''
      switch (type) {
        case 'new_price_syncro':
          order.details.forEach(p => {
            sum += p.qty * p.price
          })
          sum += +order.delivery_price
          sum -= order.discount

          result = sum == order.price ? true : false
          if (result) {
            syncroMessage = '<span class="green">OK1</span>'
          } else {
            syncroMessage = '<span class="red">ERR1</span>'
          }
          return syncroMessage

          break
        case 'price_new':
          new_text =
            '<p>' +
            order.price +
            ' + ' +
            (order.delivery_price || 0) +
            ' - ' +
            (order.discount || 0) +
            '</p>'
          break
        case 'drugs':
          console.log(order);
          if (order.details && order.details.length) {
            order.details.forEach(p => {
              text += p.new_drug.title + ' x ' + p.qty + ' ' + p.price + '<br>'
            })
          } else {
            order.preps.forEach(p => {
              text += p.drug.prep + ' x ' + p.num + ' ' + p.prep_price + '<br>'
            })
          }
          break
        case 'price':
          order.preps.forEach(p => {
            sum += p.num * p.prep_price
          })
          sum += +order.dost_price
          sum -= order.discount

          result = sum == order.price ? true : false
          if (result) {
            syncroMessage = '<span class="green">OK2</span>'
          } else {
            syncroMessage = '<span class="red">ERR2</span>'
          }
          text += order.price + ' ' + syncroMessage
          break
        case 'client':
          if (order.client_name) {
            text += order.client_name
          } else {
            if (order.order_client) text += order.order_client.name
          }
          break
        case 'address':
          text +=
            (this.cities[order.city] ? this.cities[order.city] : 'почта') +
            '<br>'
          text += order.address
          break
        case 'phones':
          if (order.phones) {
            order.phones.forEach(p => {
              if (p.phone_data) text += p.phone_data.full_phone + '<br>'
            })
          }
          break
        default:
          break
      }
      text += '</p>'
      if (new_text) return new_text
      return text
    },
    openEditOrderPage(orderId) {
      if (this.profileEditLink) {
        this.mixinGoToRouter('profilePersonalOrderEdit', {id: orderId})
        return
      }

      if (this.editInNewPage) {
        let routeData = this.$router.resolve({
          name: 'editOrder',
          params: {id: orderId}
        })
        console.log(routeData.href)
        window.open(routeData.href, '_blank')
      } else {
        this.mixinGoToRouter('editOrder', {id: orderId})
      }
    },
    async rejectOrder() {
      let {data} = await api.post('/orders/multiUpdateOrder', {
        orderId: this.modalDataReject.orderId,
        action: this.modalDataReject.type, //'rejectOrder',
        managerAction: this.modalDataReject.managerAction,
        data: {
          status: -2,
          reject_comment:
            this.modalDataReject.inputs && this.modalDataReject.inputs[0]
              ? this.modalDataReject.inputs[0].data
              : null
        }
      })

      if (data.success) {
        toastr['success']('Сохранено')
        if (this.modalDataReject.type == 'rejectOrder') {
          if (this.orders[this.modalDataReject.orderId]) {
            delete this.orders[this.modalDataReject.orderId]
          } else {
            let objectOrders = this.orders
            const index = objectOrders.findIndex((o) => o.id === this.modalDataReject.orderId)
            objectOrders[index].status = -2
            delete objectOrders[index]
            objectOrders = objectOrders.filter((o) => o)
            this.orders = objectOrders
          }
        }
        if (this.modalDataReject.type == 'rejectAgreement') {
          if (this.orders[this.modalDataReject.orderId]) {
            this.orders[
              this.modalDataReject.orderId
              ].extra_options.callDeal = false
          }

          await this.updateDynamicStoreDataByOrder(
            this.modalDataReject.orderId
          )
        }
      } else {
        toastr['warning'](data.message || 'ошибка')
      }

      this.onModalClose()
    },
    modalReject(order, type = 'order', managerAction = false) {
      let name
      if (order.client) {
        name = order.client.name
      } else {
        name = order.client_name || 'Имя не указано'
      }
      let body = '<p>' + name + '</p>'
      body += this.printPhones(order)
      body += '<p>' + order.address + '</p>'
      body += '<hr>' + this.printDrugs(order.details)

      switch (type) {
        case 'order':
          this.modalDataReject = {
            orderId: order.id,
            managerAction: managerAction,
            header: 'Отмена заявки ' + order.id,
            body: body,
            type: 'rejectOrder',
            inputs: [
              {
                label: 'Причина отмены',
                name: 'reject_reason',
                data: null,
                required: true,
                message: 'Укажите причину отмены (минимум 4 символа)'
              }
            ],
            acceptBtnText: 'Сохранить',
            cancelBtnText: 'Отмена'
          }
          break

        case 'agreement':
          this.modalDataReject = {
            orderId: order.id,
            header: 'Отмена СОГЛАСОВАНИЕ заявки ' + order.id,
            body: body,
            type: 'rejectAgreement',
            acceptBtnText: 'Сохранить',
            cancelBtnText: 'Отмена'
          }
          break
      }
    },
    modalHotCall(order) {
      let name
      if (order.client) {
        name = order.client.name
      } else {
        name = order.extra_options.client_name || 'Имя не указано'
      }
      let body = '<p>' + name + '</p>'
      body += this.printPhones(order)
      body += '<p>' + order.address + '</p>'
      body += '<hr>' + this.printDrugs(order.details)

      this.modalData = {
        orderId: order.id,
        header: 'Заявка ' + order.id,
        body: body,
        dateSelect: {
          title: 'Дата доставки',
          minDateSelect: moment().toISOString(),
          maxDateSelect: moment()
            .add(30, 'days')
            .toISOString(),
          date: moment()
            .add(1, 'days')
            .toISOString()
        },
        acceptBtnText: 'Подтвердить',
        cancelBtnText: 'Отмена'
      }
    },
    async getOrderFromStack(orderId) {
      let order = null
      if (this.orders[orderId]) {
        order = this.orders[orderId]
      } else {
        order = Object.values(this.orders).filter(o => o.id === orderId)[0]
        // order = this.orders.find((o) => o.id === orderId);
      }
      return order
    },
    async updateSubStatusByModal() {
      let order = await this.getOrderFromStack(this.modalData.orderId)
      // Promise.resolve(() => {
      //     if (typeof this.orders == 'object'){
      //         order = this.orders[this.modalData.orderId];
      //     }else {
      //         order = this.orders.find((o) => o.id === this.modalData.orderId);
      //     }
      //     return order;
      // });

      let deliveryDate = moment(this.modalData.dateSelect.date).format(
        'DD.MM.YYYY'
      )
      let {data} = await api.post('/orders/updateOrderByField', {
        orderId: this.modalData.orderId,
        resetSubStatus: this.resetSubStatus,
        fields: {
          extra_text_action: 'Выполнено дополнительное согласование',
          delivery_date: deliveryDate
        },
        extra_options: {
          callDeal: true
        }
      })

      if (data.success) {
        order.delivery_date = moment(deliveryDate, 'DD.MM.YYYY').toISOString()
        order.extra_options['callDeal'] = true

        await this.updateDynamicStoreDataByOrder(this.modalData.orderId)
      } else {
        toastr['warning'](data.message || 'ошибка')
      }

      this.onModalClose()
    },
    onModalClose(type = null) {
      if (type == 'comment') {
        this.modalCommentData = null
      }
      this.modalData = null
      this.modalDataReject = null
    },
    printOrderDate(order) {
      let dateText = ''
      switch (order.status) {
        case 0:
        case 9999:
        case 1:
          if (order.delivery_date)
            dateText = this.moment(order.delivery_date, 'DD.MM.YYYY')
          break
        case 3:
        case 11:
        case -2:
        case -3:
        case 10000:
        case 10001:
          dateText = this.moment(order.report_date, 'DD.MM.YYYY')
          break
      }
      return dateText
    },
    getClassByOrderStatus(status) {
      let className = ''
      switch (status) {
        case -2:
        case -3:
          className = 'tr_orange'
          break

        case 3:
        case 11:
          className = 'tr_green'
          break
          break
      }
      return className
    },
    printCity(cityId, type_id = 1) {
      if (type_id === 3) {
        return 'Международная доставка'
      }
      if (this.cities) {
        return this.$AllCities[cityId] && this.$AllCities[cityId].name || 'почтовая'
      } else {
        const city = Object.values(this.$AllCities).find(c => c.id === cityId)
        if (city) return city.name;
      }
    },
    printOrderStatus(order) {
      let statuses = {
        0: {status: 'primary', title: 'С сайта'},
        9999: {status: 'success', title: 'Ручная'},
        1: {status: 'info', title: 'Обработана'},
        2: {status: 'info', title: 'Назначена'},
        3: {status: 'success', title: 'Закрыта'},
        5: {status: 'success', title: 'Доставлена агентом'},
        8: {status: 'info', title: 'Спрос'},
        9: {status: 'info', title: 'Предварительная'},
        11: {status: 'success', title: 'Доставлена'},
        4: {status: 'info', title: 'Обрабатывается'},
        '-2': {status: 'warning', title: 'Отказ у менеджера'},
        '-3': {status: 'warning', title: 'Отказ у курьера'},
        '10000': {status: 'info', title: 'Архив'},
        '10001': {status: 'info', title: 'Архив'}
      }
      let text = ''
      if (order.is_agreed) {
        text += '<span class="badge badge-success">Согласовано</span>'
      }
      // console.log(order.id, order.status);
      let className = ''
      let statusTitle = order.status
      if (statuses[order.status]) {
        className = statuses[order.status].status
        statusTitle = statuses[order.status].title
      }
      if (order.pay_method === 2) {
        text += '<span class="badge badge-danger mb-1">Наложенный платеж</span>'
      }

      return (
        text +
        '<span class="badge badge-' +
        className +
        '">' +
        statusTitle +
        '</span>'
      )
    },
    async sendSelected() {
      let selected = []
      Object.keys(this.selected).forEach(k => {
        if (this.selected[k].value) selected.push(k)
      })
      if (selected.length == 0) {
        toastr['warning']('Заявки не выбраны')
        return
      }
      this.sendOrderBtnLoading = true

      let {data} = await api.post('/orders/sendOrder', {
        orderIds: selected
      })

      if (data.success) {
        this.updateOrders(
          this.orderType,
          this.orders.filter(o => !this.selected[o.id].value)
        )
        Object.keys(this.selected).forEach(
          k => (this.selected[k].value = false)
        )
        toastr['success']('Заявки отправлены')
      } else {
        toastr['warning'](data.message || 'ошибка')
      }

      this.sendOrderBtnLoading = false
    },
    updateSelected(e) {
      Object.keys(this.selected).forEach(k => {
        if (e.target.checked && !this.selected[k].disabled)
          this.selected[k].value = e.target.checked
        else if (!e.target.checked) this.selected[k].value = e.target.checked
      })
    },
    async updateSubStatus(order) {
      let {data} = await api.post('/orders/updateOrder', {order: order})
      if (data.success) {
        toastr['success']('Заявка обновлена')
      } else {
        toastr['warning'](data.message || 'ошибка')
      }
    },
    getComments(order) {
      let html = ''
      if (order.comment) {
        order.comment.forEach(c => {
          html +=
            '<div><p><small>' +
            this.printDate(c.created_at, 'DD.MM.YYYY HH:mm', 3) +
            '</small></p><p><strong>' +
            (c.user_name || 'Система') +
            '</strong> ' +
            c.text +
            '</p></div>'
        })
      }
      if (order?.extra_options?.comments_for_runner && order.extra_options.comments_for_runner.length) {
        html += '<div><p>Для курьера</p></div>'
        order.extra_options.comments_for_runner.forEach(c => {
          html +=
            '<div><p><small>' +
            c.created_at +
            '</small></p><p><strong>' +
            (c.user_name || 'Система') +
            '</strong> ' +
            c.text +
            '</p></div>'
        })
      }
      if (order.status < 0 && order.reject_comment) {
        html +=
          '<div><p><small>' + this.printDate(order.report_date, 'DD.MM.YYYY HH:mm', 3) + ' Причина отказа</small></p><p>' +
          order.reject_comment +
          '</p>'
      }
      return html
    },
    getClientName(order) {
      if (order.client_name) return order.client_name
      if (order.client) return order.client.name
      return order.extra_options.client_name || 'не указано'
    },
    printDrugs(details) {
      return this.localDisplayDrugs(details, this.type, {
        inStore: this.inStore,
        availableToSend: this.availableToSend,
        confirmedDrugs: this.confirmedDrugs
      })
    },
    printPhones(order) {
      if (!order.phones || !order.phones.length)
        return '<p>' + order.phone + '</p>'
      let phones = order.phones
      let text = ''
      phones.forEach(p => {
        if (p.phone) {
          text += '<p>+' + p.phone.country_code + ' '
          let match = p.phone.phone.match(/^(\d{3})(\d{3})(\d{2})(\d{2})$/)
          if (match) {
            text += match[1] + ' ' + match[2] + ' ' + match[3] + ' ' + match[4]
          } else {
            text += p.phone.phone
          }
          text += '</p>'
          if (p.comment) {
            text += '<p>' + p.comment + '</p>'
          }
        }
      })
      return text
    },
    moment: function (date, format) {
      if (!date) return
      return moment(date).format(format)
    },
    localDisplayDrugs2(details, type = null, options = {}) {
      let text = ''
      if (!details) return text
      details.forEach((d, key) => {
        if (!d.drug) return
        text +=
          '<div class="drug_price_details"><p>' +
          d.drug.prep +
          ' (' +
          d.drug.id +
          ')</p>'
      })
      return text
    },
    getPrePaidData(o) {
      // console.log(o.extra_options?.pre_paid_comment);
      // let html = '<p>' + (o.extra_options?.pre_paid_comment || 'Без комментария') + '</p>';
      let html = '';
      (o.paired_sms || []).forEach((s) => {
        html += `<p>${s.message}</p>`
        html += `<p class="text-muted">${this.printDate(moment(s.date).add(3, 'hours'))}</p>`
      })
      return html;
    },
    localDisplayDrugs(details, type = null, options = {}) {
      let text = ''
      if (!details) return text
      details.forEach((d, key) => {
        if (!d.drug) {
          d.drug = {
            prep: d.new_drug.title,
            id: d.new_drug.id,
            holod: d.new_drug.cool,
            komplekt: d.new_drug.pack_set,
          }
        }
        if (d.drug) {
          text +=
            '<div class="drug_price_details">';

          if (this.type == 'storeDetailed') {
            // let packSet = d.drug.komplekt != 1 ? d.drug.komplekt : 1;
            let packSet = 1
            let decimal = packSet == 1 ? 0 : 2

            if (
              this.drugDynamicStoreData &&
              this.drugDynamicStoreData[d.drug_id]
            ) {
              let dynamicStore =
                +this.drugDynamicStoreData[d.drug_id].dynamicStore || 0
              let inUse = +this.drugDynamicStoreData[d.drug_id].inUse || 0
              let inStore = +this.drugDynamicStoreData[d.drug_id].inStore || 0
              text +=
                '<div class="store_info">' +
                '<p>Динамический остаток : <strong>' +
                (dynamicStore / packSet).toFixed(decimal) +
                '</strong></p>' +
                '<p>Всего в распоряжении: <strong>' +
                (inUse / packSet).toFixed(decimal) +
                '</strong> (из них на складе: ' +
                (inStore / packSet).toFixed(decimal)
            }
            if (this.drugDynamicStoreData[d.drug_id].transitIn) {
              text +=
                ', в дороге: ' +
                (
                  +this.drugDynamicStoreData[d.drug_id].transitIn / packSet
                ).toFixed(decimal)
            }
            if (this.drugDynamicStoreData[d.drug_id].allowToSend)
              text +=
                ', возможно отправить: ' +
                (
                  +this.drugDynamicStoreData[d.drug_id].allowToSend / packSet
                ).toFixed(decimal)
            text += ')</p>'

            text +=
              '<p>Согласовано.: <strong>' +
              (
                +this.drugDynamicStoreData[d.drug_id].confirmed.total / packSet
              ).toFixed(decimal) +
              '</strong></p>'
            if (this.drugDynamicStoreData[d.drug_id].confirmed.daughter) {
              text += ' ('
              if (this.drugDynamicStoreData[d.drug_id].confirmed.current) {
                text +=
                  'текущий склад: ' +
                  (
                    +this.drugDynamicStoreData[d.drug_id].confirmed.current /
                    packSet
                  ).toFixed(decimal) +
                  ', '
              }
              text +=
                'дочерние склады: ' +
                (
                  +this.drugDynamicStoreData[d.drug_id].confirmed.daughter /
                  packSet
                ).toFixed(decimal) +
                ')'
            }
            if (this.drugDynamicStoreData[d.drug_id].readyToSend) {
              text +=
                '<p>Готовим к отправке: <strong>' +
                (
                  +this.drugDynamicStoreData[d.drug_id].readyToSend / packSet
                ).toFixed(decimal) +
                '</strong></p>'
            }
            text += '</div>'
          }

          text += '</div>'
          if (key !== details.length - 1)
            text += '<hr class="divider_of_drug_prices">'
        }
      })
      return text
    }
  }
}
</script>

<style scoped>

.price_strong {
  font-size: 15px;
}

.call_btn {
  padding: 0 7px !important;
  margin-bottom: 2px;
  margin-left: 2px;
}

.call_btn i {
  text-align: center;
}

.send_letter {
  padding-left: 5px;
  padding-top: 2px;
  color: #5bbfde;
}

.badge-empty {
  border: 1px solid lightgray;
}

.table .icon-fa {
  cursor: pointer;
}

.table .icon-fa.active {
  background-color: white;
  padding: 3px 7px;
  color: blue;
}

.w-90p {
  width: 130px;
}

.w-70p {
  width: 85px;
}

.orders_table td {
  font-size: 13px;
  color: #595959;
}

.text_date {
  font-size: 12px;
}

.table thead tr {
  background-color: #efefef;
}

.table thead th {
  font-size: 11px;
}

.table th,
.table td {
  padding: 2px 5px;
}

.table hr {
  margin: 2px 0;
}

.table p {
  margin-bottom: 0px;
}

.w-12P {
  width: 12%;
}

.w-20P {
  min-width: 200px;
  max-width: 300px;
}

.bold {
  font-weight: 600;
}

.chat_icon {
  cursor: pointer;
  color: #5bbfde;
}

.chat_btn i {
  font-size: 17px;
}
</style>

<style>
.time_ago_block .v-time-ago__text {
  color: white;
  font-size: 10px;
}

.order_address_map_popover_inner {
  width: 600px;
}

.divider_of_drug_prices {
  margin: 4px 0;
}

.cool_mark_list.icon-snowflake {
  display: inline-block;
  width: 15px;
  height: 17px;
  background: #5bbfde;
  margin: -3px 4px;
}

.title_span {
  cursor: pointer;
}

.w_title {
  cursor: pointer;
}

.comment_icon {
  cursor: pointer;
  color: #5bbfde;
}

span.green {
  color: green;
}

span.red {
  color: red;
}

.old_order_data {
  color: #acacac;
}

.drug_price_details {
  /*background-color: #dfdfdf;*/
  /*margin-bottom: 2px;*/
}

.modal_call_btn {
  padding: 2px 6px !important;
}

.orders_table hr {
  margin: 2px 0 !important;
}

.orders_table .extra_info {
  background-color: #d9d9d9;
  padding: 0 8px;
}

.orders_table .payment_icon {
  color: #60fa60;
  font-size: 20px;
  cursor: pointer;
}

.orders_table .tr_orange {
  background-color: #fdf8ee;
}

.orders_table .tr_green {
  background-color: #f1fff1;
}

.order_type.refund {
  margin-left: 5px;
  color: darkred;
}

.comment_tooltip_fa {
  font-size: 20px;
  color: #5bbfde;
  cursor: pointer;
}

.tooltip.info.custom-tooltip .tooltip-inner {
  background: rgba(91, 191, 222, 1);
  padding: 12px;
  max-width: 450px;
  text-align: left;
}

.tooltip.info.custom-tooltip .tooltip-inner div {
  margin-bottom: 10px;
}

.table.orders_table p,
.tooltip.info.custom-tooltip .tooltip-inner p {
  margin-bottom: 0px;
}

.copy_order_btn {
  padding: 0 !important;
  background-color: transparent;
}

.copy_order_btn img {
  width: 22px;
  height: 22px;
}

.store_info {
  padding: 0 5px;
  background-color: #dddddd;
}

td.relative {
  position: relative;
}

.chat_btn {
  position: absolute;
  right: 5px;
  bottom: 5px;
}

.division_label {
  background-color: gray;
  padding: 1px 5px;
  border-radius: 5px;
  color: white;
}

.alert.delivery_pass_details {
  padding: 5px 10px;
}
</style>

